'use strict';

const processInclude = require('base/util');

jQuery(() => {
    processInclude(require('base/cart/cart'));
    processInclude(require('./cart/cart'));
    processInclude(require('./product/wishlist'));
    processInclude(require('app_common/components/quantitySpinner'));
});
